
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import './index.css';
import { useAuthInitialization } from '@/hooks/useAuthInitialization';

// Create a client for React Query with improved error handling
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      meta: {
        // Use meta for custom options instead of onError directly
        errorHandler: (error: any) => {
          console.error("Query error:", error);
        }
      }
    },
    mutations: {
      meta: {
        // Use meta for custom options instead of onError directly
        errorHandler: (error: any) => {
          console.error("Mutation error:", error);
        }
      }
    }
  },
});

const Root = () => {
  const { isInitialized } = useAuthInitialization();

  if (!isInitialized) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  );
};

createRoot(document.getElementById("root")!).render(<Root />);
